var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVimeoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.943 5.247L2.13 7.797l.974 1.226c.434-.27 1.3-.972 1.688-.972.867 0 1.646 2.35 2.39 4.933.668 2.32 1.36 8.086 4.547 8.086 3.668 0 11.379-9.902 11.379-14.31 0-1.594-.316-3.889-3.492-3.889-3.403 0-5.078 3.284-5.49 4.926.297-.197 1.103-.329 1.547-.329 1.81 0 1.424 1.877 1.177 2.634-.247.756-2.144 4.442-3.168 4.442-1.25 0-1.99-5.43-2.353-7.783-.362-2.353-1.3-3.637-2.732-3.637-1.145 0-2.912 1.415-3.653 2.123z",
    fill: "#1B264F"
  })));
}
export default __webpack_public_path__ + "media/contactForm/vimeoIcon-86d348cd.svg";
export { SvgVimeoIcon as ReactComponent };